import styled from 'styled-components';
import ActionButton from 'components/ActionButton';

interface StyledGuestDirectoryExternalLinkButtonProps {
  buttonColour?: string | null;
  buttonBg?: string | null;
  buttonBorder?: string | null;
}

export const StyledGuestDirectoryExternalLinkButton = styled(
  ActionButton
)<StyledGuestDirectoryExternalLinkButtonProps>`
  margin: 0;
  width: auto;
  min-height: auto;
  text-transform: none;
  background-color: ${({ theme, buttonBg }) => buttonBg || theme.buttons.buttonHomepageBg};
  color: ${({ theme, buttonColour }) => buttonColour || theme.buttons.buttonHomepageColor};
  border: 1px solid ${({ theme, buttonBorder }) => buttonBorder || theme.buttons.buttonHomepageBorder};
`;
